<template>
  <div class="buildings_component">
    <div class="photo_container">
        <div class="border" id="sIntegrity"><div class="frame">
          <router-link to="/advocate/goldenWorld">
          <img src="./../assets/world/world.jpg"
                style="margin-top:-9px;"
                :class="{activephoto: this.active === 'sWorld', photo: this.active !== 'sWorld'}" 
                @mouseover="choosePhoto('sIntegrity')" @mouseleave="choosePhoto('')">                   
          </router-link>
        </div></div>
        <div class="border" id="sprime" ><div class="frame">
          <router-link to="/advocate/goldenDragon">
            <img src="./../assets/dragon/dragon-.jpg"
                style="margin-top:-2px;"
                :class="{activephoto: this.active === 'sprime', photo: this.active !== 'sprime'}" 
                @mouseover="choosePhoto('sprime')" @mouseleave="choosePhoto('')">            
          </router-link>
        </div></div>  
        <div class="border" id="slv" ><div class="frame">   
          <router-link to="/advocate/goldenBig">
           <img src="./../assets/big/big-.jpg"
                style="margin-top:-5px;"
                :class="{activephoto: this.active === 'slv', photo: this.active !== 'slv'}" 
                @mouseover="choosePhoto('slv')" @mouseleave="choosePhoto('')">  
          </router-link>
        </div></div> 
        <div class="border" id="splus" ><div class="frame">
          <router-link to="/advocate/goldenBerkley">
            <img src="./../assets/berkley/berkley-.jpg"
              :class="{activephoto: this.active === 'splus', photo: this.active !== 'splus'}" 
              @mouseover="choosePhoto('splus')" @mouseleave="choosePhoto('')"> 
          </router-link>
        </div></div>
    </div>
    <div class="list_container">
      <ul>
                    <!-- <li><a @mouseover="choosePhoto('')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenFront" :class="{activerouter: this.photo === ''}">金石站前湛</router-link></a></li> -->

              <li><a @mouseover="choosePhoto('goldenBig')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenBig" :class="{activerouter: this.photo === 'goldenFront'}">金石成大砌</router-link></a></li>

        <li style="width: 200px;"><a @mouseover="choosePhoto('berkley')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenBerkley" :class="{activerouter: this.photo === 'berkley'}">金石鉑克萊(完銷)</router-link></a></li>
                        <li><a @mouseover="choosePhoto('world')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenWorld" :class="{activerouter: this.photo === 'world'}">金石世築(完銷)</router-link></a></li>

        <li><a @mouseover="choosePhoto('dragon')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenDragon" :class="{activerouter: this.photo === 'dragon'}">金石龍悅</router-link></a></li>
        <li><a @mouseover="choosePhoto('sprime')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenIntegrity" :class="{activerouter: this.photo === 'sprime'}">金石喆學(完銷)</router-link></a></li>
        <li><a @mouseover="choosePhoto('sdouble')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenDouble" :class="{activerouter: this.photo === 'sdouble'}">金石雙響(完銷)</router-link></a></li>
        <li><a @mouseover="choosePhoto('sIntegrity')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenPrime" :class="{activerouter: this.photo === 'sIntegrity'}">金石首品(完銷)</router-link></a></li>
        <li><a @mouseover="choosePhoto('slv')" @mouseleave="choosePhoto('')"><router-link to="/advocate/goldenLV" :class="{activerouter: this.photo === 'slv'}">金石LV(完銷)</router-link></a></li>
        <li><a @mouseover="choosePhoto('splus')" @mouseleave="choosePhoto('')"><router-link to="/advocate/newPlus" :class="{activerouter: this.photo === 'splus'}">金石PLUS(完銷)</router-link></a></li>
      </ul>
    </div>
    <router-link class='seemore-group' id="seemore-build" to="/advocate">看更多</router-link> 
  </div>
  
</template>
 
<script>
export default {
  data(){
    return {     
      photo: '',
      active:'',
      }
  },
  methods: {
    choosePhoto(foto){
      this.photo = foto
      this.active = foto
      // console.log(this.photo)
    },
  }

}
</script>
<style scoped>
.buildings_component{
  width: 80%;
  height: auto;
  margin:25% auto 12% auto;
  background: transparent;
  position: relative;
}

.photo_container,.list_container{
  display: inline-block;
  vertical-align:middle;

}
.photo_container{
  width: 80%;
  height: auto;
  margin: 0 auto;
  position: relative;
  z-index:20;
  background: #ffffff;
}
.list_container{
  width: 190px;
  height: auto;
  margin: 0 auto 0 auto;
  background: #ffffff;
}
.border{
  border: solid 1px #bbbbbb;
  padding: 2.5% 2.8%;
  overflow: hidden;
  display: inline-block;
}
.frame{
  width: 320px;
  height: 180px;
  overflow: hidden;
  display: inline-block;
}
.photo{
  width: 320px;
  height: 190px;
  margin: auto auto;
}
@keyframes popover{
  0%{ 
    width: 320px;
    height: 180px;
    }
  100%{
    width: 380px;
    height: 200px;
    margin-top:0px;
    margin-left:-30px}
}
.activephoto{
  animation: popover 0.3s linear forwards;
  -webkit-animation:popover 0.3s linear forwards;
  animation-delay:0s;
  -webkit-animation-delay: 0s;
  cursor: pointer;
}
#sIntegrity{  margin: 0 1% 1% 0;}
#sprime{ margin: 0 0 1% 1%;}
#slv{ margin: 1% 1% 0 0;}
#splus{ margin: 1% 0 0 1%;}

.list_container > ul li{
  list-style-type: none;
  text-decoration: none;
}
.list_container a{
  width: 60%;
  height: auto;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.17;
  letter-spacing: 1.43px;
  text-align: justify;
  color: #7d7d7d;
  text-decoration: none;
}
a :hover{
  color: #d0ad76;
}
a .router-link-exact-active{
  color: #d0ad76;
}
a .activerouter{
  color: #d0ad76;
}
.seemore-group{
  padding-top:10px;
  padding-bottom:0;
  width: auto;
  height:auto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.17px;
  text-align: justify;
  color: #d0ad76;
  text-decoration: none;
  border-bottom: solid 1px #d0ad76;
}
.seemore-group:hover{ cursor: pointer;}

#seemore-build{ 
  margin: 0 2.5% 0 0;
  float:right;
}
</style>